import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule, RouterOutlet } from '@angular/router';
import { doc, Firestore, setDoc } from '@angular/fire/firestore';
import { Observable, Subscription } from 'rxjs';
import { AdminAuthComponent } from '../../auth/admin-auth-component/admin-auth-component';
import { Tournament } from '../shared/tournament';
import { TournamentCategory } from '../shared/tournament-category';
import { OpenSquashService } from '../shared/services/open-squash-service';

@Component({
  selector: 'app-open-femenino1-component',
  imports: [RouterModule, RouterOutlet, CommonModule, MatButtonModule],
  templateUrl: './open-femenino1-component.html',
  styleUrl: './open-femenino1-component.scss',
})
export class OpenFemenino1Component {
  private openSquashService = inject(OpenSquashService);
  private dialog = inject(MatDialog);
  private firestore = inject(Firestore);

  // El torneo aún no existe en Firestore: mostramos el botón "Crear Torneo" (solo admin).
  torneoCreado = true;

  tournament!: Tournament;
  categories: TournamentCategory[] = [];
  esAdmin$!: Observable<boolean>;
  tournamentSubscription!: Subscription;

  ngOnInit(): void {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    console.log('1. estableciendo torneo> open-femenino1');
    this.openSquashService.setTournament('1open-femenino');
    console.log('2. recibiendo info torneo> open-femenino1');
    this.tournamentSubscription = this.openSquashService.tournament$.subscribe(
      (tournament) => {
        console.log('1. result query torneo recibido', tournament);
        this.torneoCreado = true;
        this.tournament = tournament;
        this.categories = tournament.categories.sort(
          (a, b) => a.categoryOrder - b.categoryOrder
        );
      },error => {
        console.error('Error al cargar el torneo open-femenino1:', error);
      }
    );
  }

  authAdmin() {
    this.dialog
      .open(AdminAuthComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.openSquashService.setAsAdmin(true);
        }
      });
  }

  logout() {
    this.openSquashService.setAsAdmin(false);
  }

  async crearTorneo() {
    // Torneo especial (no genera ranking): dos categorías, cada una con grupos A y B.
    const categorias = ['Damas A', 'Damas B'];

    const tournament = {
      name: '1 Open Femenino Squash',
      categories: categorias.map((cat, i) => ({
        category: cat,
        categoryOrder: i + 1,
        groups: [
          { name: 'A', players: [] },
          { name: 'B', players: [] },
        ],
        players: [],
        finals: {},
        hasQuarterFinals: false,
        hasSemiFinals: false,
        hasFinal: false,
      })),
    };

    const ref = doc(this.firestore, 'tournament/1open-femenino');
    await setDoc(ref, tournament);
    this.torneoCreado = true;
    console.log('Torneo 1open-femenino creado en Firestore');
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }
}
